<template>
  <div>
    <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" />
    <div id="app" v-if="repayDetail">
      <div class="list-box ">
        <div class="title">CASHE DETAILS</div>
        <div class="flex flex-align-center flex-justify-between">
          <div class="font-16 left-text">AMOUNT TO REPAY</div>
          <div class="font-15" style="color: red;">Rs. {{ repayDetail.all_amount }}</div>
        </div>
        <div class="flex flex-align-center flex-justify-between margin-top-24" v-if="repayDetail.status === 0">
          <div class="font-16 left-text">STATUS</div>
          <div class="font-15" style="color: red;"> Cash in review </div>
        </div>
        <div class="flex flex-align-center flex-justify-between margin-top-24" v-else>
          <div class="font-16 left-text">STATUS</div>
          <div class="font-15" style="color: red;">DUE ON {{ repayDetail.cycle }}</div>
        </div>
        <div class="flex flex-align-center flex-justify-between  margin-top-24">
          <div class="font-16  left-text">CURRENT DUE</div>
          <div class="font-15">REPAY Rs.{{ repayDetail.all_amount }}</div>
        </div>

      </div>
      <div class="list-box ">
        <div class="title">BREAKDOWN OF</div>
        <div class="flex flex-align-center flex-justify-between">
          <div class="font-16 left-text">TOTAL CASH</div>
          <div class="font-15">Rs. {{ repayDetail.all_amount }}</div>
        </div>
        <div class="flex flex-align-center flex-justify-between  margin-top-24">
          <div class="font-16 left-text">INTEREST</div>
          <div class="font-15">Rs. {{ repayDetail.rate }}</div>
        </div>
        <div class="flex flex-align-center flex-justify-between  margin-top-24">
          <div class="font-16 left-text">IN-HAND AMOUNT</div>
          <div class="font-15">Rs. {{ repayDetail.amount }}</div>
        </div>
        <div class="flex flex-align-center flex-justify-between  margin-top-24">
          <div class="font-16 left-text">REQUESTED ON</div>
          <div class="font-15">{{ repayDetail.create_at }}</div>
        </div>
        <div class="flex flex-align-center flex-justify-between  margin-top-24">
          <div class="font-16 left-text">APPORED ON</div>
          <div class="font-15"> {{ repayDetail.end_at }}</div>
        </div>
        <div class="flex flex-align-center flex-justify-between  margin-top-24">
          <div class="font-16 left-text">DISBURSED ON</div>
          <div class="font-15">{{ repayDetail.settle_at }}</div>
        </div>
      </div>
      <div class="fixed repay-box">
        <!-- <div @click="rollover" class="rollover">
          Go to roll over
          <van-icon name="arrow" />
        </div> -->
        <div class="theme-back repay" @click="rollover(2)">
          Go to roll over
        </div>
        <div class="repay_between" v-if="Number(repayDetail.half_amount) > 0">
          <div class="theme-back repay "
            style="background-color: #fff;border: 1px solid #333;color: #333; width: 48%;box-sizing: border-box;"
            @click="rollover(3)">
            Partial repay
          </div>
          <div class="theme-back repay " style="width: 48%;background-color: #05b1ff;opacity: 0.5"
            v-if="repayDetail.status === 0">
            Repay Now
          </div>
          <div class="theme-back repay" style="width: 48%;background-color: #05b1ff;" @click="firstCash" v-else>
            Repay Now
          </div>
        </div>
        <div v-else style="margin-top: 10px;">
          <div class="theme-back repay " style="background-color: #05b1ff;opacity: 0.5"
            v-if="repayDetail.status === 0">
            Repay Now
          </div>
          <div class="theme-back repay" style="background-color: #05b1ff;" @click="firstCash" v-else>
            Repay Now
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      product_id: null,
      repayDetail: null
    }
  },
  created() {
    if (this.$route.query.order_id) { this.order_id = this.$route.query.order_id, this.getRepaymentDetails(this.$route.query.order_id) }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    async rollover(type) {
      const { data: res } = await this.$http.post('/api/Product/repayment', { orderId: this.order_id, type: type })
      if (res.code === 0) {
        window.location.href = res.data.url
      } else {
        this.$toast(res.msg)
      }
    },
    async firstCash() {
      const { data: res } = await this.$http.post('/api/Product/repayment', { orderId: this.order_id })
      if (res.code === 0) {
        window.location.href = res.data.url
      } else {
        this.$toast(res.msg)
      }
    },
    async getRepaymentDetails(order_id) {
      const { data: res } = await this.$http.post('/api/product/repayDetail', { orderId: order_id })
      if (res.code === 0) {
        this.repayDetail = res.data;
      } else {
        this.$toast(res.msg)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: #F9F9F9;
  min-height: 100vh;
  padding: 12px 12px 0px 12px;
  box-sizing: border-box;

  .title {
    font-size: 15px;
    color: #FFA06A;
    font-weight: 500;
    margin-bottom: 20px;
  }

  .list-box {
    background: #FFFFFF;
    padding: 14px;
    border-radius: 14px;

    .left-text {
      color: #666666;
    }
  }

  .repay-box {
    bottom: 10px;
    margin: 0 38px;
    left: 0;
    right: 0;
    text-align: center;
    box-sizing: border-box;

    .rollover {
      height: 22px;
      font-size: 16px;
      color: #FF5D00;
      line-height: 22px;
      margin-bottom: 10px;
    }

    .repay {
      padding: 12px 0px;
      font-size: 16px;
      color: #FFFFFF;
      font-weight: bold;
      border-radius: 24px;
    }

    .repay_between {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
  }

}
</style>
